module.exports = __webpack_public_path__ + "static/media/Help.a643c6b7.svg";